// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151149/js/" + chunkId + "." + {"44":"28de17bb","225":"a4181ba3","481":"051a3671","486":"2d852de0","770":"92e10861"}[chunkId] + ".0.692925397386814.chunk.js";
};